export default "__VITE_ASSET__13535677__"